import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { RoutesModule } from './routes/routes.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';

import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/primeng';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    HttpClientModule,
    LayoutModule,
    RoutesModule,
    SharedModule.forRoot()
  ],
  providers: [CookieService, DatePipe, MessageService],
  bootstrap: [AppComponent]
})
export class AppModule { }
